<template>
  <div name="products-policies">
    <Tabs class="tabs">
      <template
        v-for="(tab, index) in tabs"
        v-slot:[`tab-title-${index}`]="{ title, tabObj }"
      >
        <span :key="tab.title" class="tabs--title">
          <img :src="tabObj.extraData.flag" />
          {{ title }}
        </span>
      </template>

      <Tab
        v-for="tab in tabs"
        :extraData="tab"
        :key="tab.title"
        :title="tab.title"
        class="tabs--item"
      >
        <div>
          <!-- DESCRIÇÃO -->
          <Textarea
            :value="displayDescriptionValue(tab.code)"
            :counter="true"
            :maxlength="1500"
            :tooltipMinWidth="225"
            :label="`Política Resumida do Produto (${tab.label})`"
            infoText="Resumo das políticas aplicadas neste produto. Será demonstrado no bloco do Site Letsbook, caso você tenha."
            placeholder=""
            class="form--input__general-policy-description"
            infoIcon
            @input="resumeHandler($event, tab.code)"
          />
        </div>
      </Tab>
    </Tabs>

    <!-- POLÍTICAS  -->
    <Tabs v-for="(item, i) in productData.politicas" :key="i" class="tabs">
      <template
        v-for="(tab, index) in tabs"
        v-slot:[`tab-title-${index}`]="{ title, tabObj }"
      >
        <span :key="tab.title" class="tabs--title">
          <img :src="tabObj.extraData.flag" />
          {{ title }}
        </span>
      </template>

      <!-- BOTÃO PARA REMOVER -->
      <span class="tabs--button-remove" @click="removeGeneralPolicy(i)"
        >Excluir</span
      >

      <Tab
        v-for="tab in tabs"
        :extraData="tab"
        :key="tab.title"
        :title="tab.title"
        class="tabs--item"
      >
        <div>
          <!-- TÍTULO DA POLÍTICA -->
          <PmwFormInput
            :value="item.find((item) => item.idioma === tab.code)?.nome"
            :maxlength="150"
            :error="errors.includes('politicas')"
            data-error="politicas"
            label="Título da política"
            placeholder=""
            class="form--input__general-policy-title"
            showCounter
            @input="nameHandler($event, i, tab.code)"
          />

          <!-- DESCRIÇÃO -->
          <Textarea
            :value="item.find((item) => item.idioma === tab.code)?.texto"
            :counter="true"
            :maxlength="1500"
            :error="errors.includes('politicas')"
            data-error="politicas"
            label="Descrição"
            placeholder=""
            class="form--input__general-policy-description"
            @input="descriptionHandler($event, i, tab.code)"
          />
        </div>
      </Tab>
    </Tabs>

    <!-- ADICIONAR NOVA POLÍTICA -->
    <PmwButton
      :hasIcon="true"
      layout="outline"
      variation="blue-100"
      class="button__outline form--button"
      @click="addGeneralPolicy()"
    >
      Adicionar política
    </PmwButton>
  </div>
</template>

<script>
/** Bandeiras de idiomas */
import en from '@/assets/images/en-flag.png'
import es from '@/assets/images/es-flag.png'
import pt from '@/assets/images/ptbr-flag.png'

import Tab from '@/components/_base/patterns/Tab'
import Tabs from '@/components/_base/patterns/Tabs'
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'

import debounce from 'lodash.debounce'

export default {
  name: 'ProductPolicies',
  components: {
    Tab,
    Tabs,
    Textarea,
    PmwButton,
    PmwFormInput
  },

  props: {
    /** Dados do produto */
    productData: {
      type: Object,
      default: () => {}
    },
    /* Array de erros */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tabs: [
        {
          title: 'PT',
          label: 'Português',
          flag: pt,
          dataAttribute: 'pt-BR',
          code: 3
        },
        {
          title: 'EN',
          label: 'English',
          flag: en,
          dataAttribute: 'en-US',
          code: 2
        },
        {
          title: 'ES',
          label: 'Español',
          flag: es,
          dataAttribute: 'es-ES',
          code: 1
        }
      ]
    }
  },

  async created() {
    if (this.productData.politicas && this.productData.politicas?.length) {
      await this.productData.politicas.forEach((item) => {
        item.forEach((subItem) => {
          if (!subItem.texto) {
            subItem.texto = ''
          }
        })
      })
    }
  },

  methods: {
    /** Retorna a descrição do idioma selecionado
     * @param {Number} code - Código do item selecionado
     */
    displayDescriptionValue(code) {
      return this.productData.textos.find((item) => item.idioma === code)
        ?.politicaResumida
    },

    /** Manipula a mudança de valores do titulo da politica
     * @param {String} $event - Texto do titulo da politica
     * @param {Number} index - Posição do item no array
     * @param {Number} tabCode - Código de idioma da tab atual
     */
    nameHandler: debounce(function($event, index, tabCode) {
      const langMatch = this.productData.politicas[index].find(
        (item) => item.idioma === tabCode
      )

      if (langMatch) {
        this.$set(langMatch, 'nome', $event)
      } else {
        this.productData.politicas.push({
          idioma: tabCode,
          nome: $event
        })
      }
    }, 200),

    /** Manipula a mudança de valores do texto da politica
     * @param {String} $event - Texto da descrição da politica
     * @param {Number} index - Posição do item no array
     * @param {Number} tabCode - Código de idioma da tab atual
     */
    descriptionHandler: debounce(function($event, index, tabCode) {
      const langMatch = this.productData.politicas[index].find(
        (item) => item.idioma === tabCode
      )

      if (langMatch) {
        this.$set(langMatch, 'texto', $event)
      } else {
        this.productData.politicas.push({
          idioma: tabCode,
          texto: $event
        })
      }
    }, 200),

    /** Manipula a mudança de valores da politica resumida
     * @param {String} $event - Texto do texto do resumo
     * @param {Number} tabCode - Código de idioma da tab atual
     */
    resumeHandler: debounce(function($event, tabCode) {
      const langMatch = this.productData.textos.find(
        (item) => item.idioma === tabCode
      )

      if (langMatch) {
        this.$set(langMatch, 'politicaResumida', $event)
      } else {
        this.productData.textos.push({
          idioma: tabCode,
          politicaResumida: $event
        })
      }
    }, 200),

    /** Remover política
     * @param {Number} index: Posição da política que será removida
     */
    removeGeneralPolicy(index) {
      return this.productData.politicas.splice(index, 1)
    },

    /** Adicionar política  */
    addGeneralPolicy() {
      this.productData.politicas.push([
        {
          idioma: 1,
          nome: null,
          texto: '',
          grupoIdiomas: 0
        },
        {
          idioma: 2,
          nome: null,
          texto: '',
          grupoIdiomas: 0
        },
        {
          idioma: 3,
          nome: null,
          texto: '',
          grupoIdiomas: 0
        }
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }
    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}
.form {
  &--input {
    max-width: 176px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__general-policy-title {
      max-width: 424px;
      margin-bottom: 50px;
    }

    &__general-policy-description {
      max-width: 697px;
    }
  }

  &--button {
    width: auto;
  }
}

.button {
  &__outline ::v-deep {
    .pmw-button--icon__left {
      gap: 10px;
    }
  }
}

.tabs {
  margin-bottom: 24px;
  border: 1px solid pmw-colors('grey-20');
  position: relative;

  &--title {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &--button-remove {
    color: pmw-colors('error-100');
    font-weight: font-weight('weight-medium');
    position: absolute;
    top: 0px;
    right: 0px;
    margin: 17px 16px 0px 0px;
    cursor: pointer;
  }

  ::v-deep {
    .tabs--head {
      margin: 0px;
    }
    .tabs--content {
      padding: 32px 29px;
    }
    .tab {
      padding: 12px 20px 10px 15px;
    }
  }
}
</style>
